import { Routes } from '@angular/router';

import { advaniaServicesSegments } from '@advania-cosoftware/wolf-router';

export const databaseEngineManagementRoutes: Routes = [
    {
        path: advaniaServicesSegments.databaseEngineManagement,
        loadComponent: () =>
            import('./pages/database-engine-management-page/database-engine-management.page').then(
                (m) => m.DatabaseEngineManagementPage,
            ),
    },
];
